module.exports = __webpack_public_path__ + "img/design_people_how_think.3d6e215c.jpg";